import { bloomTokenColumn } from "../resource/bloom-token-column";
import { NeededColumn } from "./needed-column";

export const bloomTokenNeededColumn = new NeededColumn(
  "7559b586-891e-42ad-891b-06eadd49e419",
  bloomTokenColumn,
  "Bloom Token Needed"
)
